import {
  Time,
  Distance,
  Pace,
  calculateTime,
  calculateDistance,
  calculatePace,
  isNoTime
} from "./pace-fns/pace-fns";

export type CalculatorState = {
  time: Time;
  distance: Distance;
  pace: Pace;
};

export enum FieldId {
  Time = "time",
  Pace = "pace",
  Distance = "distance"
}


export const isTimeValid = (time: Time) => !!time && !isNoTime(time);
export const isPaceValid = (pace: Pace) => isDistanceValid(pace?.distance) && isTimeValid(pace.time);
export const isDistanceValid = (distance: Distance) => distance?.units !== 0 && !!distance?.units;

export const generateCalculatorState = (
  pendingState: CalculatorState,
  fieldToCalculate: FieldId
): CalculatorState => {
  switch (fieldToCalculate) {
    case FieldId.Time:
      return {
        distance: pendingState.distance,
        pace: pendingState.pace,
        time: calculateTime(pendingState.distance, pendingState.pace)
      };
    case FieldId.Distance:
      return {
        time: pendingState.time,
        pace: pendingState.pace,
        distance: calculateDistance(pendingState.time, pendingState.pace, {
          unitOfMeasure: pendingState.distance.unitOfMeasure!
        })
      };
    case FieldId.Pace:
      return {
        time: pendingState.time,
        distance: pendingState.distance,
        pace: calculatePace(pendingState.time, pendingState.distance, {
          pacePerGivenDistance: pendingState.pace.distance
        })
      };
    default:
      throw Error("Must specify valid field to calculate");
  }
};
